module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/privatenotes/privatenotes.component.css
// module id = ./src/app/components/privatenotes/privatenotes.component.css
// module chunks = main